var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTableBenchCError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 63 26",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M61.4 2.24v22.08l-4.642.464A1.6 1.6 0 0 1 55 23.192V8.64a1.6 1.6 0 0 0-1.6-1.6H22.27a1.6 1.6 0 0 1-1.585-1.814l.62-4.586h38.494a1.6 1.6 0 0 1 1.6 1.6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M61.399 25.6a.64.64 0 0 0 .64-.64V2.24A2.24 2.24 0 0 0 59.799 0h-39.36a.64.64 0 0 0 0 1.28h39.36c.53 0 .96.43.96.96v22.72c0 .354.286.64.64.64Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M18.519 20.16a1.6 1.6 0 0 0 1.6 1.6h31.36a1.6 1.6 0 0 0 1.6-1.6v-9.6a1.6 1.6 0 0 0-1.6-1.6h-31.36a1.6 1.6 0 0 0-1.6 1.6v9.6Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M.92 2.24v22.08l4.64.464a1.6 1.6 0 0 0 1.76-1.592V8.64a1.6 1.6 0 0 1 1.6-1.6h31.128a1.6 1.6 0 0 0 1.586-1.814L41.014.64H2.518a1.6 1.6 0 0 0-1.6 1.6Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M.92 25.6a.64.64 0 0 1-.64-.64V2.24A2.24 2.24 0 0 1 2.52 0h39.36a.64.64 0 1 1 0 1.28H2.52a.96.96 0 0 0-.96.96v22.72a.64.64 0 0 1-.64.64Z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M43.8 20.16a1.6 1.6 0 0 1-1.6 1.6H10.84a1.6 1.6 0 0 1-1.6-1.6v-9.6a1.6 1.6 0 0 1 1.6-1.6H42.2a1.6 1.6 0 0 1 1.6 1.6v9.6Z"
})));
SvgNoTableBenchCError.viewBox = '0 0 63 26';
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTableBenchCError);
export default ForwardRef;